import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { initializeAppCheckService } from './appCheck';

// ローカル開発で Firebase Emulator Suite に接続するか（E2E/ローカル検証用）
const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';

// Firebase設定
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Firebase初期化
const app = initializeApp(firebaseConfig);

// App Check を初期化（不正利用対策）。他のFirebaseサービスより前に実行する。
// Emulator 使用時は App Check を初期化しない。
export const appCheck = useEmulator ? null : initializeAppCheckService(app);

// Firebaseサービスのエクスポート
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// callable のリージョンはデプロイ先（asia-northeast1）と一致させる必要がある
export const functions = getFunctions(app, 'asia-northeast1');

// Emulator への接続（VITE_USE_FIREBASE_EMULATOR=true のときのみ）
if (useEmulator) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  console.info('🔧 Firebase Emulator Suite に接続しました (auth:9099 / firestore:8080 / storage:9199 / functions:5001)');
}

export default app;
